import { useState } from 'react';

export interface FormDefaultsState {
  // Todo creation defaults
  initialDueDate: string | null;
  setInitialDueDate: (date: string | null) => void;
  initialTodoDate: string | null;
  setInitialTodoDate: (date: string | null) => void;
  initialActiveInWeek: boolean;
  setInitialActiveInWeek: (active: boolean) => void;
  initialActiveInMonth: boolean;
  setInitialActiveInMonth: (active: boolean) => void;
}

export function useFormDefaults(): FormDefaultsState {
  const [initialDueDate, setInitialDueDate] = useState<string | null>(null);
  const [initialTodoDate, setInitialTodoDate] = useState<string | null>(null);
  const [initialActiveInWeek, setInitialActiveInWeek] = useState<boolean>(false);
  const [initialActiveInMonth, setInitialActiveInMonth] = useState<boolean>(false);

  return {
    initialDueDate,
    setInitialDueDate,
    initialTodoDate,
    setInitialTodoDate,
    initialActiveInWeek,
    setInitialActiveInWeek,
    initialActiveInMonth,
    setInitialActiveInMonth
  };
}
